/**
 * 这个文件也不知道该咋加注释，基本上代码就告诉你这些函数是干嘛的了。
 */
function loadImg(url, cross = false) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    cross && img.setAttribute('crossOrigin', 'anonymous')
    img.src = url
    img.onload = function() {
      if (this.complete) {
        resolve(img)
      }
    }
    img.onerror = function() {
      if (this.complete) {
        reject(img)
      }
    }
  })
}

async function loadImgs(urls) {
  let imgs = []
  imgs.push(loadImg(urls[0], true))
  imgs.push(loadImg(urls[1]))

  try {
    let rets = await Promise.all(imgs)
    return rets
  } catch (e) {
    return null
  }
}

/**
 * @function dataURLtoFile   - 将base64转换为文件对象
 * @param {string} dataurl   - base64编码串.
 * @param {string} filename  - 转换后的文件名.
 * @return {object}          - 转换后的文件对象.
 */
function dataURLtoFile(dataURI, filename) {
  var arr = dataURI.split(',')
  const bytes = window.atob(arr[1])
  let mime = arr[0].match(/:(.*?);/)[1]
  let suffix = mime.split('/')[1]
  const ab = new ArrayBuffer(bytes.length)
  const ia = new Uint8Array(ab)
  for (let i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i)
  }
  var blob = new Blob([ab], { type: mime })
  return { blob: blob, name: filename + '.' + suffix }
}

async function createImg(bgPic, qrCode, callback) {
  try {
    const imgs = await loadImgs([bgPic, 'data:image/png;base64,' + qrCode])
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')

    let devicePixelRatio = window.devicePixelRatio || 1
    let backingStoreRatio = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1
    let ratio = devicePixelRatio / backingStoreRatio

    let canvasW = 750
    let canvasH = 1334
    canvas.setAttribute('width', canvasW * ratio)
    canvas.setAttribute('height', canvasH * ratio)
    canvas.style.width = canvasW + 'px'
    canvas.style.height = canvasH + 'px'
    ctx.scale(ratio, ratio)
    ctx.fillStyle = '#3F4954'
    ctx.fillRect(0, 0, canvasW, canvasH)

    ctx.drawImage(imgs[0], 0, 0, canvasW, canvasH)
    // ctx.arc(375, 970, 113, 0, 2 * Math.PI)
    // ctx.clip()
    ctx.drawImage(imgs[1], 275, 870, 200, 200)

    const base64 = canvas.toDataURL('image/jpeg', 0.1)
    const fileName = new Date().getTime()
    if (callback) {
      callback(dataURLtoFile(base64, fileName))
    } else {
      return Promise.resolve(dataURLtoFile(base64, fileName))
    }
  } catch (e) {
    if (callback) {
      callback(null)
    } else {
      return null
    }
  }
}
export { createImg, dataURLtoFile }
